import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/ApiClient";

// 로그인 화면이 노출할 소셜 프로바이더 목록. 서버(/api/auth-providers)가 실제로
// 자격증명을 가진 프로바이더만 돌려주므로, 이 값으로 버튼을 게이팅하면 "설정 안 된
// 죽은 버튼"이 안 뜬다. 공개(무인증) 엔드포인트라 세션 이전 로그인 화면에서 부를 수 있다.
// staleTime 무한: 값은 배포 단위 상수라 세션 동안 다시 받을 필요가 없다. 실패하면
// 소셜 버튼을 감추고 이메일 폼만 남긴다(빈 배열) — 인증의 기본 경로는 항상 살아있다.
export function useAuthProvidersQuery() {
  return useQuery({
    queryKey: ["auth-providers"],
    staleTime: Infinity,
    queryFn: async () => {
      const res = await apiClient.api["auth-providers"].$get();
      // 실패 시 소셜 없이 폴백(이메일 폼은 그대로 동작)
      if (!res.ok) return { providers: [] as string[] };
      const body = await res.json();
      return { providers: body.providers as string[] };
    },
  });
}
